var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner-row",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_SignContract"),
        width: "600px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { "font-size": "16px", color: "#4389D0" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("CargoMsg.Cargo_ContractedClientInformation")) +
            " "
        )
      ]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              staticStyle: { "padding-left": "35px", "padding-top": "20px" },
              attrs: { "label-width": "85px", "label-position": "left" }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ChineseNamed"),
                    no: "1"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.client.name || "") + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_EnglishNamed"),
                    no: "2"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.client.englishName || "") + " ")]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentState === "match",
                      expression: "currentState === 'match'"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        color: "#4389D0",
                        "margin-left": "-35px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SignContractTip")))]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1, no: "3" },
                          model: {
                            value: _vm.joinGroup,
                            callback: function($$v) {
                              _vm.joinGroup = $$v
                            },
                            expression: "joinGroup"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SignContractTipYes"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "companyRadioGroup",
                          staticStyle: {
                            height: "200px",
                            "overflow-y": "auto"
                          },
                          attrs: { disabled: _vm.joinGroup === 0 },
                          model: {
                            value: _vm.curCompany,
                            callback: function($$v) {
                              _vm.curCompany = $$v
                            },
                            expression: "curCompany"
                          }
                        },
                        _vm._l(_vm.companyList, function(company) {
                          return _c(
                            "el-radio-button",
                            {
                              key: company.uuid,
                              attrs: {
                                label: company.uuid,
                                border: "",
                                no: "4"
                              },
                              model: {
                                value: _vm.curCompany,
                                callback: function($$v) {
                                  _vm.curCompany = $$v
                                },
                                expression: "curCompany"
                              }
                            },
                            [
                              _c("p", [_vm._v(_vm._s(company.chineseName))]),
                              _c("p", [_vm._v(_vm._s(company.englishName))])
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            label: 0,
                            disabled: !_vm.enabledNoJoin,
                            no: "5"
                          },
                          model: {
                            value: _vm.joinGroup,
                            callback: function($$v) {
                              _vm.joinGroup = $$v
                            },
                            expression: "joinGroup"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SignContractTipNo"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("el-form-item")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "6" },
              on: { click: _vm.confirmClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SignContract")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "7" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }